import { message } from '@/components';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';

export interface RecordingStateChangeResp {
  status: number;
}

export default function useRecordingStateChange() {
  const { meeting } = useLocalStore(() => {
    return {
      meeting: meetingModel,
    };
  });
  const { formatMessage } = useIntl();

  const change = (body: RecordingStateChangeResp) => {
    const { status } = body;
    const changeState = `${meeting.videoRecordingState}-${status}`;
    switch (changeState) {
      case '3-1':
        message.info({
          content: formatMessage({ id: 'MEETING_RECORDING_ENABLED' }),
          noIcon: true,
        });
        break;
      case '2-1':
        message.info({
          content: formatMessage({ id: 'RECORDING_RESUMED' }),
          noIcon: true,
        });
        break;
      case '2-3':
      case '1-3':
        message.info({
          content: formatMessage({ id: 'RECORDING_STOPPED' }),
          noIcon: true,
        });
        break;
      case '1-2':
        message.info({
          content: formatMessage({ id: 'RECORDING_PAUSED' }),
          noIcon: true,
        });
        break;
      default:
    }
    meeting.setVideoRecording(status);
  };

  return change;
}
